$.i18n().load({
    "sr-Cyrl": {
        msg_activecode_load_history: "Учитај историју",
        msg_activecode_audio_tour: "Аудио тура",
        msg_activecode_loaded_code: "Ваш изворни код је учитан.",
        msg_activecode_no_saved_code: "Не постоји снимљен код.",
        msg_activecode_run_code: "Покрени програм",
        msg_activecode_show_feedback: "Прикажи резултат",
        msg_activecode_show_code: "Прикажи код",
        msg_activecode_hide_code: "Затвори код",
        msg_activecode_show_codelens: "Корак по корак",
        msg_activecode_show_in_codelens: "Корак по корак",
        msg_activecode_hide_codelens: "Затвори корак по корак",

        msg_sctivecode_parse_error:
            "Синтаксна грешка (parse error) значи да Пајтон не разуме синтаксу у линији кога на коју порука о грешци указује. Типични примери овакве грешке су заборавлјена двотачка код 'if' или 'for' исказа или заборављена запета између аргумената код позива функције",
        msg_sctivecode_parse_error_fix:
            "Да бисте исправили синтаксну грешку треба пажњиво да погледате линију изворног кода на коју указује поруга о грешци и можда претходну линину изворног кода. Проверите да ли су поштована сва синтаксна правила Пајтона.",
    },
});
